import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import organizationReducer from './slices/organizationSlice';
import adminUnitReducer from './slices/adminUnitSlice';
import memberReducer from './slices/memberSlice';
import caseReducer from './slices/caseSlice';
import notificationReducer from './slices/notificationSlice';
import uiReducer from './slices/uiSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    organization: organizationReducer,
    adminUnit: adminUnitReducer,
    member: memberReducer,
    case: caseReducer,
    notification: notificationReducer,
    ui: uiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Allow non-serializable values like modal components
    }),
});

export default store;